import { BrandMark } from '@/components/ui/brand-loader';

/**
 * Inline loading indicator for buttons and other compact controls: the
 * full-colour PlanWise mark drawn in sheet by sheet. Size comes from `size` or
 * a size class.
 */
export function Spinner({ size = 16, className = '' }: { size?: number; className?: string }) {
  return <BrandMark size={size} variant="loading" className={className} />;
}
